import { isGlobalFeatureEnabled } from "owa-feature-flags";

export function isCollabSpaceReadEnabled(): boolean {
    return (
    // Functionality restricted to Teams client as per EU settlement
    // cal-disable-meeting-notes will be rolled out to "true" for everything except Teams
    !isGlobalFeatureEnabled("cal-disable-meeting-notes") &&
        (isGlobalFeatureEnabled("cal-cmp-fluidCollaborativeSpace") ||
            isGlobalFeatureEnabled("cal-fluid-collabSpaceRead")));
}
